export default "__VITE_ASSET__CAlEoqV2__"